import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieGridProps {
  items: Movie[];
  className?: string;
}

export default function MovieGrid({ items, className = '' }: MovieGridProps) {
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5 ${className}`}>
      {items.map((movie) => (
        <MovieCard key={movie.id} movie={movie} />
      ))}
    </div>
  );
}